import { React, Component, _ } from "utils";
import { withRouter } from "react-router-dom";
import { App } from "model";
import "./back.less";

class Back extends Component {
  back = () => {
    let currentPath = this.props.location.pathname;
    let jobsMatch = new RegExp("^/jobs");
    let eventsMatch = new RegExp("^/events");
    let offersMatch = new RegExp("/offers$");
    let offersMatchWithJob = new RegExp("/offers/");

    if (jobsMatch.test(currentPath)) {
      if (currentPath !== "/jobs") {
        this.props.history.push("/jobs");
      } else {
        this.props.history.push("/");
      }
    } else if (eventsMatch.test(currentPath)) {
      if (currentPath !== "/events") {
        this.props.history.push("/events");
      } else {
        this.props.history.push("/");
      }
    } else if (offersMatch.test(currentPath)) {
      let newPath = currentPath.replace(offersMatch, "");
      this.props.history.push(newPath);
    } else if (offersMatchWithJob.test(currentPath)) {
      let position = currentPath.search(offersMatchWithJob, "");
      let newPath = currentPath.slice(0, position) + "/offers";
      this.props.history.push(newPath);
    } else {
      this.props.history.goBack();
    }
  };

  render() {
    return (
      <span className="back" onClick={this.back}>
        <img src={App.resourceUrl("back.svg")} alt={_("Back")} />
      </span>
    );
  }
}

export default withRouter(Back);



// WEBPACK FOOTER //
// ./src/modules/components/back.js